import { render, staticRenderFns } from "./ChengXinCompany.vue?vue&type=template&id=d93c033e&scoped=true"
import script from "./ChengXinCompany.vue?vue&type=script&lang=js"
export * from "./ChengXinCompany.vue?vue&type=script&lang=js"
import style0 from "./ChengXinCompany.vue?vue&type=style&index=0&id=d93c033e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d93c033e",
  null
  
)

export default component.exports